module.exports = __webpack_public_path__ + "bb994af1cff58166a95c3a9a55d7cfb0.png";